module.exports = __webpack_public_path__ + "u13.no2.74cdafae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/u13.no2.jpg
// module id = HhzS
// module chunks = 0